export * from './datesFormat';
export const SITE_CODE = {
    OLXKZ: 'olxkz',
    OLXUZ: 'olxuz',
    OLXUA: 'olxua',
    OLXRO: 'olxro',
    OLXPT: 'olxpt',
    OLXBG: 'olxbg',
    OLXPL: 'olxpl'
};

export const LOCALE = {
    PL: 'pl-PL',
    UA: 'uk-UA',
    KZ: 'kk-KZ',
    UZ: 'uz-UZ',
    PT: 'pt-PT',
    BG: 'bg-BG',
    RO: 'ro-RO'
};

export const bookingHowToUseHelpLink = {
    PL: 'https://pomoc.olx.pl/olxplhelp/s/article/Jak-rezerwowa%C4%87-za-pomoc%C4%85-Kalendarza-rezerwacji',
    UA: 'https://help.olx.ua/olxuahelp/s/article/Календар-бронювання-у-Подобовій-оренді',
    KZ: 'https://help.olx.kz/olxkzhelp/s/article/%D0%9A%D0%B0%D0%BA-%D0%BF%D0%BE%D0%BB%D1%8C%D0%B7%D0%BE%D0%B2%D0%B0%D1%82%D1%8C%D1%81%D1%8F-%D0%9A%D0%B0%D0%BB%D0%B5%D0%BD%D0%B4%D0%B0%D1%80%D0%B5%D0%BC-%D0%B1%D1%80%D0%BE%D0%BD%D0%B8%D1%80%D0%BE%D0%B2%D0%B0%D0%BD%D0%B8%D1%8F?language=ru',
    UZ: '',
    PT: '',
    BG: '',
    RO: 'https://ajutor.olx.ro/olxhelpro/s/article/Cum-rezerv-cu-ajutorul-calendarului'
};
export const bookingHelpManagementLinkText = {
    PL: 'https://pomoc.olx.pl/olxplhelp/s/article/Zarz%C4%85dzanie-Kalendarzem-rezerwacji',
    UA: 'https://help.olx.ua/olxuahelp/s/article/Календар-бронювання-у-Подобовій-оренді',
    KZ: 'https://help.olx.kz/olxkzhelp/s/article/%D0%A3%D0%BF%D1%80%D0%B0%D0%B2%D0%BB%D0%B5%D0%BD%D0%B8%D0%B5-%D0%9A%D0%B0%D0%BB%D0%B5%D0%BD%D0%B4%D0%B0%D1%80%D0%B5%D0%BC-%D0%B1%D1%80%D0%BE%D0%BD%D0%B8%D1%80%D0%BE%D0%B2%D0%B0%D0%BD%D0%B8%D1%8F',
    UZ: '',
    PT: '',
    BG: '',
    RO: 'https://ajutor.olx.ro/olxhelpro/s/article/Gestionarea-calendarului-de-rezervari'
};
